import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Hero, Section, CTA } from "../components/Page/Page.js";
import { projects } from "../data/content.js";

export default function ProjectsScreen() {
  const cats = ["All", ...new Set(projects.map((p) => p.category))];
  const [c, setC] = useState("All");
  return (
    <>
      <Hero title="Our Projects" text="Community-based climate projects, certified and measured." />
      <Section>
        <div className="pg-filter">
          {cats.map((x) => <button key={x} className={x === c ? "on" : ""} onClick={() => setC(x)}>{x}</button>)}
        </div>
        <div className="pg-pgrid">
          {projects.filter((p) => c === "All" || p.category === c).map((p) => (
              <Link key={p.slug} className="pg-pcard" to={`/projects/${p.slug}`}>
                <img src={p.image} alt={p.title} loading="lazy" />
                <h3>{p.title}</h3>
                <p>{p.status}: {p.tagline}</p>
              </Link>
          ))}
        </div>
      </Section>
      <CTA />
    </>
  );
}
